<h1 mat-dialog-title>Check Network</h1>
<div mat-dialog-content>
    <div class="content">
        <p>We are checking the following domains to make sure you are able to access them:</p>

        <p *ngFor="let domain of domains">
            <span>Checking {{ domain.label }}...</span>
            <span [ngSwitch]="domain.status">
                <span *ngSwitchCase="ConnectionStatus.Success" class="success">passed</span>
                <span *ngSwitchCase="ConnectionStatus.Failed" class="failed">failed</span>
                <ng-template ngSwitchDefault class="pending">pending</ng-template>
            </span>
        </p>

        <p>
            <span
                >If any of the domains has failed, it probably has not been whitelisted on the dealership's networks. For quick access, you can temporarily
                disable the WiFi connection on a mobile device and log in using the mobile network. For future access, the dealership should make sure all three
                domains have been whitelisted, including on the guest network.
            </span>
        </p>
    </div>
</div>
<div class="form-footer">
    <button mat-button class="primary" (click)="close()">Close</button>
</div>
